import { SLAMetricType, TicketPriority, type SLABreachAlert } from '@/types/sla';

export function buildBreachCsv(alerts: SLABreachAlert[]): string {
  const cell = (value: unknown) => {
    const text = String(value ?? '');
    const safe = /^[=+@\t\r]/.test(text) ? "'" + text : text;
    return '"' + safe.replace(/"/g, '""') + '"';
  };
  const rows = alerts.map(alert => [
    alert.ticketNumber, alert.title, TicketPriority[alert.priority] ?? 'Unknown',
    SLAMetricType[alert.metricType] ?? 'Unknown', alert.dueDate, alert.timeRemaining,
    alert.assignedAgentName, alert.isBreached ? 'Breached' : 'At risk'
  ]);
  return [['Ticket', 'Subject', 'Priority', 'Metric', 'Due date (UTC)', 'Minutes remaining', 'Assigned agent', 'Status'], ...rows]
    .map(row => row.map(cell).join(',')).join('\r\n');
}
